import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch } from 'react-redux';
import { fakeAction } from 'redux/slices/transaction';
import visa_logo from 'assets/icons/visa_blue.svg';

import PriceInput from 'components/PriceInput';
import Select from 'components/Select';
import ModalWithChildren from 'components/ModalWithChildren';
import LabelWithChildren from 'components/LabelWithChildren';
import { cancelPayment as TEXT } from 'locales/en/transaction';
import { priceFromAPI } from 'utils/price';
import { CURRENCY_SYMBOL } from 'utils/transform';

const CancelPayment = ({ transaction, className }) => {
  const { control, handleSubmit } = useForm({
    defaultValues: {
      amount: priceFromAPI(transaction.amount),
    },
  });
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const onClickConfirm = () => {
    setIsLoading(true);
    dispatch(fakeAction()).then(() => {
      setIsOpen(false);
      setIsLoading(false);
    });
  };

  return (
    <>
      <button className={className} onClick={() => setIsOpen(true)}>
        {TEXT.title}
      </button>
      {isOpen && (
        <ModalWithChildren
          isOpen
          header={TEXT.title}
          isLoading={isLoading}
          ctaTitle={isLoading ? TEXT.cancelling : TEXT.title}
          onClickCta={handleSubmit(onClickConfirm)}
          cta2Title={TEXT.cancel}
          onClickCta2={() => setIsOpen(false)}
        >
          <>
            <div className="mt-12">
              <div>
                <FontAwesomeIcon icon="info-circle" />
                <span className="ml-2 text-sm text-javelin-gray-dark">
                  {TEXT.message}
                </span>
              </div>
            </div>
            <div className="grid gap-y-5 mt-7">
              <PriceInput
                labelClassName="text-xs text-javelin-gray-light w-40 mb-1 lg:mb-0"
                label={TEXT.amount}
                className="flex flex-col lg:items-baseline mb-0 lg:flex-row"
                inputClassName="flex-1"
                name="amount"
                control={control}
                inputPrefix={CURRENCY_SYMBOL[transaction.currency]}
                thousandSeparator
                fixedDecimalScale
                decimalScale={2}
                disabled
              />
              <div className="relative flex flex-row items-center justify-between">
                <span className="text-xs text-javelin-gray-light w-40">
                  {TEXT.paymentMethod}
                </span>
                <div className="flex items-center flex-1">
                  <img
                    className="w-6 ml-0 mr-1 overflow-visible inline rounded-sm"
                    src={visa_logo}
                    alt="Visa ending in 1234"
                  />
                  <span className="h-full text-javelin-gray-dark text-xs">
                    {transaction.last4 ? `ending in ${transaction.last4}` : '-'}
                  </span>
                </div>
              </div>
              <LabelWithChildren
                labelClassName="text-xs text-javelin-gray-light w-40 lg:mt-4 mb-1 lg:mb-0"
                label={TEXT.reason}
                className="-mb-2 lg:items-start"
              >
                <div>
                  <Select
                    disabled
                    placeholder={TEXT.selectReason}
                    className="flex-1"
                  />
                  <textarea
                    className="text-sm rounded-md border-javelin-inputBorder resize-none w-full mt-2 flex-1 placeholder-javelin-placeholder"
                    rows={5}
                    placeholder={TEXT.addMore}
                  />
                </div>
              </LabelWithChildren>
            </div>
          </>
        </ModalWithChildren>
      )}
    </>
  );
};

CancelPayment.propTypes = {
  transaction: PropTypes.shape({}),
  className: PropTypes.string,
};
CancelPayment.defaultProps = {
  className: 'btn btn-secondary w-40 h-11 px-0',
};

export default CancelPayment;
